import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex justify-end gap-6 max-md:mt-2 lg:mb-8 lg:justify-between',
    link: 'group heading-xs hover:text-icon-brand flex items-center gap-2'
  }
});
